<template>
  <div width="100%" class="ml-0 pl-0">
    <!-- SImple toolbar -->
    <v-toolbar prominent>
      <v-toolbar-title class="headline black--text">Your Dashboard</v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-text-field
          label="Search for an Idea(s)"
          prepend-inner-icon="mdi-magnify"
          clearable
          rounded
          :append-icon="searchText ? 'mdi-send': ''"
          v-model="searchText"
          color="black"
          outlined
          class="mt-4"
          @keyup.enter="searchIdea(searchText)"
          @click:append="searchIdea(searchText)"
        ></v-text-field>
      </template>
    </v-toolbar>

    <!-- General summary review cards -->

    <v-row class="my-5 mx-5" align="center">
      <v-flex md3 v-for="(st, i) in summary" :key="i">
        <!-- <summary-card></summary-card> -->
        <ideaSummary :stat="st"></ideaSummary>
      </v-flex>
    </v-row>

    <!-- reporting cards -->
    <v-row class="my-5 mx-5" align="center">
      <v-flex md4 class="pa-2" v-for="(prof, i) in stat.participation.profession" :key="i">
        <report-card :report="prof"></report-card>
      </v-flex>
    </v-row>

    <!-- Registation Approval -->
    <v-row class="my-5">
      <v-flex md="6">
        <registration-approval class="ml-4"></registration-approval>
      </v-flex>
      <!-- Donut Chart -->
      <v-flex md="3">
        <v-row class="ml-5" justify="end">
          <sliced-donut :gender="stat.participation.gender"></sliced-donut>
        </v-row>
      </v-flex>
    </v-row>
  </div>
</template>

<script>
import summaryCard from "@/components/summaryCard";
import ideaSummary from "@/components/IdeaSummaryCard";
import reportCard from "@/components/reportingCard";
import registrationApproval from "@/components/registrationApproval";
import slicedDonut from "@/components/slicedDonut";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    "summary-card": summaryCard,
    "report-card": reportCard,
    "registration-approval": registrationApproval,
    "sliced-donut": slicedDonut,
    ideaSummary: ideaSummary
  },
  data() {
    return {
      searchText: ""
    };
  },
  created() {
    this.getSummary();
  },
  computed: {
    ...mapState("auth", ["stat"]),
    summary() {
      var obj = [];
      for (var key of Object.keys(this.stat)) {
        if (typeof this.stat[key] != "object") {
          obj.push({ key: key, value: this.stat[key] });
        }
      }
      return obj;
    },
  },
  methods: {
    ...mapActions("auth", ["getSummary"])
  }
};
</script>